module.exports = __webpack_public_path__ + "img/menu_setting_off.15eceeba.svg";